var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 22a5 5 0 0 1-5-5v-6a1 1 0 1 1 2 0v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-6a1 1 0 1 1 2 0v6a5 5 0 0 1-5 5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15a1 1 0 0 1-1-1V5.914L8.207 8.707a1 1 0 0 1-1.414-1.414L11 3.086 11.086 3 12 2.086l.914.914.086.086 4.207 4.207a1 1 0 0 1-1.414 1.414L13 5.914V14a1 1 0 0 1-1 1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15a1 1 0 0 1-1-1V5.914L8.207 8.707a1 1 0 0 1-1.414-1.414L11 3.086 11.086 3 12 2.086l.914.914.086.086 4.207 4.207a1 1 0 0 1-1.414 1.414L13 5.914V14a1 1 0 0 1-1 1"
})));
export default SvgShare;